import React, { useState, useContext } from "react";
import AuthContext from "../AuthContext";
import AllOrders from '../components/Sanction Order/AllOrder';
import AddOrders from '../components/Sanction Order/AddOrder';
import UpdateOrder from '../components/Sanction Order/UpdateOrder';

function PurchaseDetails() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const authContext = useContext(AuthContext);

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  // Toggle Add Order Modal
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Toggle Update Order Modal
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add Order Modal */}
        {showProductModal && (
          <AddOrders
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Update Order Modal */}
        {showUpdateModal && (
          <UpdateOrder
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Sanction Order</h2>
            <div className="flex gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
                onClick={addProductModalSetting}
              >
                Add Sanction Order
              </button>
            </div>
          </div>
          <AllOrders
            handlePageUpdate={handlePageUpdate}
            updateProductModalSetting={updateProductModalSetting}
          />
        </div>
      </div>
    </div>
  );
}

export default PurchaseDetails;
